import styled from 'styled-components';
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';

// Constellation Components
import {
    Text,
} from '@zillow/constellation';

export const StyledBannerText = styled(Text)`
    font-weight: bold;
    text-align: center;
`;

export const StyledInvoicePaymentContainer = styled(StyledContainer)`
    background: white;
    margin-bottom: 20px;
`;
